import { Product } from '../../types/Products/Products';
import { auth } from '../../constants/firebaseModular';
import * as Sentry from '@sentry/browser';

export const getProduct = async (uid: string): Promise<Product | undefined> => {
  try {
    const url = `${import.meta.env.VITE_CLOUDFUNCTIONS_URI}/api/products/${uid}`;
    const token = await auth.currentUser?.getIdToken();
    if (!token) {
      throw new Error('User is not authenticated');
    }

    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const res = await fetch(url, {
      method: 'GET',
      headers: myHeaders,
    });

    if (res.status !== 200) {
      alert(`ERROR: ${res.status}: ${res.statusText}`);
      throw new Error(`ERROR: ${res.status}: ${res.statusText}`);
    }
    const data = await res.json();
    return data;
  } catch (error) {
    console.error('Error requesting domain discount', error);
    Sentry.captureException(error);
  }
};
